@if (label) {
  <span [class]="column.badgeClass(item)">{{ label }}</span>
} @else {
  <span class="text-muted">-</span>
}
